import * as React from 'react';
import { Table, TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col, Label, Input } from 'reactstrap';
import { useState, useEffect } from 'react';
import Page from '../Page';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { Entity, getSelectedEntity } from '../../redux/EntitySlice';
import {
    Afr, getSelectedAfr, updateVersionStateValue, generateLocalStateFromEventProperties, versionStateValue, updateTableFact, existFactsInTable, getTable, hasNoDataFact,
    removeNoDataFact, addNoDataFact
} from '../../redux/AfrSlice';
import { setIsDirty, isAdmin, getTaxonomyType, getSectionDimensionMap } from '../../redux/MiscSlice';
import { Concept, resetConceptState } from "../../redux/ConceptSlice";
import utilityHelper from '../../utils/utilityHelper';
import { useLocation } from 'react-router-dom';
import enums from '../../utils/enums';
import { IAccountEditorGridNoSubaccountsOptions } from '../core/AccountEditorGridNoSubAccountBulk';
import { RowDimensionEditorGrid } from '../core/RowDimensionEditorGrid';
import { loadDefinitionNetworkRoot, NetworkDetailsRequest, selectDefinitionNetworkRoot } from '../../redux/NetworkSlice';
import { ActiveTaxonomyVersionInfo, selectCurrentVersion, TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import { getTaxonomy } from '../../redux/DocumentsSlice';
import { Node, Edge } from '../../redux/EntitiesSlice';

export const getNetworkFilters = function (n: any | null, section: string): Concept[] {
    var newFilters: Concept[] = [];
    var sectKey = "CR_939_" + section;
    if (n && n.hasOwnProperty(sectKey) ) {
        return n[sectKey];
    }
    console.log("should not be here", n);
    return newFilters;
}
export const getNetworkFilterIds = function (n: any | null, section: string): string[] {
    var newFilters: string[] = [];
    var sectKey = "CR_939_" + section;
    if (n && n.hasOwnProperty(sectKey)) {
        n[sectKey].map((x : Concept )=> newFilters.push(x.id));
    }
    return newFilters;
}
const getReviewKey = function (dataSection: string) {
    return "reviewState_cr939" + dataSection + "Reviewed";
}
const DataSection939 = (props: { userRole: string, dataSection: string }) => {
    const dispatch = useAppDispatch();

    const networkRoot: Node | null = useAppSelector(selectDefinitionNetworkRoot);
    const sectDimMap: any = useAppSelector(getSectionDimensionMap);
    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const afrYear = currentAfr ? currentAfr.year : 0;
    const entity: Entity | null = useAppSelector(getSelectedEntity);
    const ename = entity ? entity.name : "";
    const ecode = entity ? entity.code : "";
    const [state, setState] = useState(generateLocalStateFromEventProperties(currentAfr, ["workState_" + props.dataSection, getReviewKey(props.dataSection) ]));
    const [activeTab, setActiveTab] = useState("1");
    const [hasFacts, setHasFacts] = useState(true);
    const [bsDocumentation, setBsDocumentation] = useState<string[]>([]);
    const [revTitle, setRevTitle] = useState<string>("Revenues");
    const [expTitle, setExpTitle] = useState<string>("Expenditures");
    const [balanceForward, setBalanceForward] = useState<number>(0);
    const [noData, setNoData] = useState<boolean>(false);
    const fetchNoData = function () {
        var newState: any = {};
        return newState;
    }
    const [noData939, setNoData939] = useState<any>(fetchNoData());

    const getNoData = function () {
        return noData939;
    }
    const updateHasFacts = function (newState : any) {
//        setNoData(newState);
    }

    const isAdminUser: boolean = useAppSelector(isAdmin);
    /* ************************************** Redux ********************************************/

    const toggle = (tab: string) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
            utilityHelper.saveDeferredChanges(dispatch);
        }
    }

    const activeClass = (tab: string) => {
        return (tab === activeTab) ? "active" : "";
    }


    const currVersion = function () {
        if (currentAfr) {
            if (currentAfr.currentversion) {
                if (currentAfr.currentversion.versionState) {
                    return currentAfr.currentversion.versionState;
                }
            }
        }
        return null;
    }

    // Cell Handler
    const handleCellEdited = function (cell: any) {
        var row = cell.getRow();
        var rowid = row.getData().accountCode;
        var conceptId = row.getData().accountId;
        var fieldid = cell.getField();
        var newvalue = cell.getValue();
        dispatch(updateTableFact(
            {
                tableId: "939-court-reporting-revenues",
                rowId: rowid,
                fundGroup: fieldid,
                concept: conceptId,
                value: newvalue
            }));

    }

    const handleChangeCheckbox = function (event: any) {

        var checkValues = JSON.parse(JSON.stringify(state));
        var key: string = event.target.name;
        var value: boolean = event.target.checked

        setState(checkValues);

        // here call to dispatcher sending:
        var eventFirstlevel = key.split("_")[0]
        var eventSecondlevel = key.split("_")[1]

        // Update global flag for this event in redux
        dispatch(updateVersionStateValue({ propGroup: eventFirstlevel, propName: eventSecondlevel, boolValue: value, value: null }));

        // set the dirty flag to TRUE
        dispatch(setIsDirty({ IsDirty: true, Page: "" }));

    }
    const handleChangeNoDataCheckbox = function (event: any) {
        var tbl = getTable(currentAfr, "uas_001b_afr-no-data-declarations");
        if (!tbl) {
            console.log("no nd table!!!");
            return;
        }
        var key: string = event.target.name;
        var value: boolean = event.target.checked
        // Treat this as a toggle, however the value supplied is the new state
        if (!value) {
            dispatch(removeNoDataFact(props.dataSection));
        } else {
            dispatch(addNoDataFact(props.dataSection));
        }

        // set the dirty flag to TRUE
        dispatch(setIsDirty({ IsDirty: true, Page: "" }));

    }

    const editorOptions: IAccountEditorGridNoSubaccountsOptions = {
        gridname: "revenues",
        cellEditHandler: handleCellEdited,
        doneFlag: "workState_revenuesComplete",
        noFlag: "workState_noRevenues",
        fixedRows: false,
        firstFieldId: "FG_001_GeneralFundMember",
        allowedCombinations: null,
        dimensionColumn: null,
        accountRangeFilter: null,
        accountGroups: null,
        columnFilter: null
    };

    const headerStyle = {
        margins: "4em, 0, 0, 0",
        backgroundColor: "green"
    }
    useEffect(() => {
        setNoData(true);
        if (!currentAfr) return;
        if (!currentAfr.currentversion) return;
        // get state from redux
        var newLocalState = generateLocalStateFromEventProperties(currentAfr, ["workState_" + props.dataSection, getReviewKey(props.dataSection)])
        // enable/disable checkbox when there are (no) facts 
        setHasFacts(existFactsInTable(currentAfr, ["939-court-reporting-revenues","939-court-reporting-expenditures"]))
        setNoData(hasNoDataFact(currentAfr,props.dataSection));
        // create a local state from redux
        setState(newLocalState)

    }, [currentAfr, currVersion()])

    useEffect(() => {
        var req: NetworkDetailsRequest = {
            networkId: "classes-of-939-court-reporting",
            nodeId: "CR_939_" + props.dataSection,
            taxonomyInfo: {
                type: TaxonomyTypeEnum.COURT_REPORTING_939,
                year: 2011,
                periods: [],
                id: "",
                isPublished: true
            }
        }
        dispatch(loadDefinitionNetworkRoot(req));
        setRevTitle("Revenues for " + props.dataSection);
        setExpTitle("Expenditures for " + props.dataSection);
        var bTotal = 0;
        if (currentAfr) {
            bTotal = utilityHelper.getTableRevenuesMinusExpenditures(
                                                getTable(currentAfr, "939-court-reporting-revenues"),
                                                getTable(currentAfr, "939-court-reporting-expenditures"),
                                                getNetworkFilterIds(sectDimMap, props.dataSection)
                                            );
        }
        setBalanceForward(bTotal);
        
    }, [])

    return (
        <React.Fragment>
            <Page>
                <h2>{utilityHelper.camelCaseToTitleCase(props.dataSection)} for {ename} ({ecode}), {utilityHelper.getAfrYearDescriptor(currentAfr)}</h2>
                <Row>
                    <Col>
                        <div className="box-events pl-2 pr-3 py-3 my-2">
                            <div>
                                <Label className="ml-4" check>
                                    <Input type="checkbox"
                                        name={props.dataSection}
                                        onChange={handleChangeNoDataCheckbox}
                                        checked={noData}
                                        disabled={true}
                                    />{' '} <b>No {utilityHelper.insertSpacesInCamelCase(props.dataSection).trim()} Items</b>
                                </Label>
                                {isAdminUser && (
                                    <Label className="ml-5" check>
                                        <Input type="checkbox"
                                            name={getReviewKey(props.dataSection)}
                                            onChange={handleChangeCheckbox}
                                            disabled={!utilityHelper.checkStatusList(currentAfr, enums.certifiedRecertified)}
                                            checked={state[getReviewKey(props.dataSection)] ? true : false}
                                        /><b>Reviewed</b>
                                    </Label>)}
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div>
                            <Row style={{ marginBottom: "2em" }}>
                                <Col>
                                    <div><h2 >Revenues</h2></div>
                                    <RowDimensionEditorGrid
                                        componentTitle={revTitle}
                                        tableName="939-court-reporting-revenues"
                                        affiliateCode=""
                                        noDataState=""
                                        gridData={[]}
                                        gridColumns={[]}
                                        gridOptions={{}}
                                        gridId={"cr939revenues"}
                                        dimensionFilter={getNetworkFilters(sectDimMap, props.dataSection)}
                                        taxonomyType={TaxonomyTypeEnum.COURT_REPORTING_939}
                                        noData={getNoData()}
                                        updateHasFacts={updateHasFacts}
                                    />
                                </Col>
                            </Row>
                            <Row style={{ marginBottom: "2em" }}>
                                <Col>
                                    <div><h2>Expenditures</h2></div>
                                    <RowDimensionEditorGrid
                                        componentTitle={expTitle}
                                        tableName="939-court-reporting-expenditures"
                                        affiliateCode=""
                                        noDataState=""
                                        gridData={[]}
                                        gridColumns={[]}
                                        gridOptions={{}}
                                        gridId={"cr939expenditures"}
                                        dimensionFilter={getNetworkFilters(sectDimMap, props.dataSection)}
                                        taxonomyType={TaxonomyTypeEnum.COURT_REPORTING_939}
                                        noData={getNoData()}
                                        updateHasFacts={updateHasFacts}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div><h2>Next Quarter Carry Forward: {utilityHelper.FormatterWithDecimals(balanceForward + "", "XBRLI_MONETARYITEMTYPE",0)}</h2></div>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Page>
        </React.Fragment>
    );
}

export default DataSection939;